export default __webpack_public_path__ + "static/media/nb.98f3253e.png";